// extracted by mini-css-extract-plugin
export default {"container":"_quick-contact_container__8dSFZ","avatar":"_quick-contact_avatar__KgAfi","user_name":"_quick-contact_user_name__tqP0z"};